import React from "react";
import Alert from "components/Alert";
import Checkbox from "components/Checkbox";
import DropdownSelect, { SelectOption } from "components/DropdownSelect";
import { BuildingCalculationEngine } from "api-client";
import { useTranslation } from "react-i18next";
import { buildingSettingsStore } from "../BuildingSettingsStore";
import { observer } from "mobx-react-lite";

const MassCalculation = () => {
  const { t } = useTranslation();

  const ENGINE_OPTIONS: SelectOption[] = [
    {
      id: BuildingCalculationEngine.Matrices,
      name: (
        <div>
          <div className="text-sm font-medium">
            {t("buildingSettings.calculationEngineV2")}
          </div>
          <div className="text-xs font-normal text-gray-500">
            {t("buildingSettings.calculationEngineV2Description")}
          </div>
        </div>
      ),
    },
    {
      id: BuildingCalculationEngine.ImportedMass,
      name: (
        <div>
          <div className="text-sm font-medium">
            {t("buildingSettings.calculationEngineV3")}
          </div>
          <div className="text-xs font-normal text-gray-500">
            {t("buildingSettings.calculationEngineV3Description")}
          </div>
        </div>
      ),
    },
  ];
  const { settings } = buildingSettingsStore;

  const selectedEngine =
    ENGINE_OPTIONS.find((option) => option.id === settings.calculation_mode) ??
    null;

  return (
    <div>
      <div className="text-lg font-semibold mb-2">
        {t("buildingSettings.calculationRules")}
      </div>
      <div className="text-gray-700 text-sm font-normal mb-6">
        {t("buildingSettings.massCalculationSubtitle")}
      </div>

      <DropdownSelect
        labelName={t("buildingSettings.calculationEngine")}
        options={ENGINE_OPTIONS}
        defaultValue={selectedEngine}
        onChange={(option) =>
          buildingSettingsStore.onChangeValue(
            (option?.id as BuildingCalculationEngine) ?? undefined,
            "calculation_mode"
          )
        }
        containerClassName="mb-6"
      />

      <Alert
        type="info"
        description={t("buildingSettings.massCalculationAlert")}
      />
      <div className="flex items-center mb-6">
        <Checkbox
          id="use_imported_mass"
          checked={Boolean(buildingSettingsStore.settings.use_imported_mass)}
          onChange={(e) =>
            buildingSettingsStore.onChangeValue(
              e.currentTarget.checked,
              "use_imported_mass"
            )
          }
          className="mr-2"
        />
        <div className="mt-6">
          <div className="text-sm font-medium text-gray-700">
            {t("buildingSettings.useImportedMassTitle")}
          </div>
          <div className="text-sm font-normal text-gray-500">
            {t("buildingSettings.useImportedMassSubtitle")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(MassCalculation);
